import { createTheme } from "@mui/material/styles";

export const careCenterThemes = {
  cc_431: createTheme({
    custom: {
      primary: { main: "#39659A" },
    },
  }),
};
